import { post, get } from '../axios'

// 新建弹窗
export function autoPopup_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_AUTOPOPUP}/autoPopup/add`,
    map,
    option
  ).then(response => response)
}

// 删除弹窗
export function autoPopup_delete_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_AUTOPOPUP}/autoPopup/delete/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 弹窗详情
export function autoPopup_detail_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_AUTOPOPUP}/autoPopup/detail/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 编辑弹窗
export function autoPopup_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_AUTOPOPUP}/autoPopup/edit`,
    map,
    option
  ).then(response => response)
}

// 弹窗列表
export function autoPopup_list_get(map, option) {
  return get(
    `${process.env.VUE_APP_AUTOPOPUP}/autoPopup/list`,
    map,
    option
  ).then(response => response)
}
